import { FC, memo, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useRidesNavigation } from "@ryde/redux";
import {
  getRideRouteInfo,
  IRideRoute,
  Log,
  MapRouteBlockTypeEnum,
  selectedRidesSelector,
} from "@ryde/shared";

import { RideGridTableMapStyled } from "./rides-grid.styled";
import { RidesMapSelectInner } from "./rides-map-select.inner";

const RidesMapMultiSelectComponent: FC = () => {
  const selectedRides = useRecoilValue(selectedRidesSelector);
  useRidesNavigation();
  const selectedRidesRoutes: IRideRoute[] = useMemo(() => {
    Log.debug(
      "Multi select grid, routes for selected rides for map re-evaluated",
      selectedRides,
    );
    return selectedRides.map(getRideRouteInfo);
  }, [selectedRides]);
  return (
    <RideGridTableMapStyled>
      <div className="map_scrollable_content">
        <RidesMapSelectInner
          routes={selectedRidesRoutes}
          routeBlockType={MapRouteBlockTypeEnum.GridMultiSelect}
        />
      </div>
    </RideGridTableMapStyled>
  );
};

export const RidesMapMultiSelect = memo(RidesMapMultiSelectComponent);
